import { BaseValidator } from '../core/BaseValidator.js';
import { ValidationResult } from '../core/ValidationResult.js';
import { ChecksumCalculator } from '../utils/ChecksumCalculator.js';

/**
 * Dutch BSN validator following Single Responsibility Principle
 */
export class BsnValidator extends BaseValidator {
  constructor() {
    super({
      name: 'Dutch BSN',
      pattern: /^\d{9}$/,
      length: 9
    });
  }

  validateFormat(id) {
    // Check length
    const lengthValidation = this.validateLength(id, this.config.length);
    if (!lengthValidation.isValid) {
      return lengthValidation;
    }

    // Check pattern
    return this.validateRegex(
      id,
      this.config.pattern,
      'BSN must be exactly 9 digits'
    );
  }

  validateChecksum(id) {
    if (!ChecksumCalculator.calculateBsnChecksum(id)) {
      return ValidationResult.invalid('Invalid BSN checksum');
    }

    return ValidationResult.valid('Valid BSN');
  }
}